var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-scroll-view", { staticClass: "settings-root" }, [
    _c(
      "div",
      { staticClass: "settings-content" },
      [
        _c(
          "w-link",
          {
            staticClass: "back-link",
            on: {
              click: function ($event) {
                return _vm.$router.push("/portal/settings")
              },
            },
          },
          [
            _c("w-fa", { attrs: { icon: "arrow-left" } }),
            _vm._v(" " + _vm._s(_vm.$ct("back")) + " "),
          ],
          1
        ),
        _vm.dossier
          ? [
              _c("div", { staticClass: "head" }, [
                _c("h1", [_vm._v(_vm._s(_vm.dossier.DossierName))]),
                _c("div", { staticClass: "company" }, [
                  _vm._v(_vm._s(_vm.dossier.CompanyName)),
                ]),
              ]),
              _c(
                "w-card",
                [
                  _c(
                    "w-card-content",
                    [
                      _c("app-dossier-integration-form", {
                        attrs: {
                          dossier: _vm.dossier,
                          "exact-connected": _vm.exactStatus.Connected,
                          "clearfacts-connected":
                            _vm.clearfactsStatus.Connected,
                        },
                        on: {
                          saved: function ($event) {
                            return _vm.onSaved($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          : _vm.loading
          ? _c(
              "w-row",
              { attrs: { center: "" } },
              [
                _c(
                  "w-col",
                  { attrs: { center: "" } },
                  [_c("w-progress-circular", { attrs: { large: "" } })],
                  1
                ),
              ],
              1
            )
          : _c("p", { staticClass: "hint" }, [
              _vm._v(" " + _vm._s(_vm.$ct("not-found")) + " "),
            ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }